import { type RouteRecordRaw } from 'vue-router'

export const printShopEmbedRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/PrintShopEmbedView.vue'),
    meta: {
      authZ: ({ user }) => user.can('create', 'physical-media'),
      title: 'marketing.print-shop',
    },
    name: 'brand.marketing.print-shop',
    path: 'marketing/print-shop',
  },
]
